<template>
  <!-- Profile Info Tab -->
  <div id="emp_profile" class="pro-overview tab-pane fade show active">
    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Personal Information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                <div class="title">Salutation</div>
                <div class="text">
                  {{ personalInformation.salutation_name }}
                </div>
              </li>
              <li>
                <div class="title">Full Name</div>
                <div class="text">
                  {{
                    personalInformation.first_name
                      ? ` ${personalInformation.first_name}`
                      : ""
                  }}{{
                    personalInformation.middle_name
                      ? ` ${personalInformation.middle_name}`
                      : ""
                  }}
                  {{
                    personalInformation.last_name
                      ? ` ${personalInformation.last_name}`
                      : ""
                  }}
                </div>
              </li>
              <li>
                <div class="title">Father/Husband Name</div>
                <div class="text">
                  {{
                    personalInformation.husband_father_name != null
                      ? personalInformation.husband_father_name
                      : "N/A"
                  }}
                </div>
              </li>
              <li>
                <div class="title">CNIC</div>
                <div class="text">{{ personalInformation.cnic_number }}</div>
              </li>
              <li>
                <div class="title">Expiry Date</div>
                <div class="text">{{ personalInformation.cnic_exp_date }}</div>
              </li>
              <li>
                <div class="title">Email</div>
                <div class="text text-email">
                  {{ personalInformation.personal_email_address }}
                </div>
              </li>
              <li>
                <div class="title">DOB</div>
                <div class="text">{{ personalInformation.dob }}</div>
              </li>
              <li>
                <div class="title">City</div>
                <div class="text">{{ personalInformation.city_name }}</div>
              </li>
              <li>
                <div class="title">Country</div>
                <div class="text">{{ personalInformation.country_name }}</div>
              </li>
              <li>
                <div class="title">Marital status</div>
                <div class="text">{{ personalInformation.marital_status }}</div>
              </li>
              <li>
                <div class="title">Religion</div>
                <div class="text">{{ personalInformation.religion_name }}</div>
              </li>
              <li>
                <div class="title">Gender</div>
                <div class="text">{{ personalInformation.gender_name }}</div>
              </li>
              <li>
                <div class="title">Nationality</div>
                <div class="text">
                  {{ personalInformation.nationality_name }}
                </div>
              </li>
              <li>
                <div class="title">Blood Group</div>
                <div class="text">
                  {{ personalInformation.blood_group_name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-u profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Contact Information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                <div class="title">Primary Contact Number</div>
                <div class="text">
                  {{ contactInformation.primary_contact_no }}
                </div>
              </li>
              <li>
                <div class="title">Secondary Contact Number</div>
                <div class="text">
                  {{ contactInformation.secondary_contact_no }}
                </div>
              </li>
              <li>
                <div class="title">Landline Number</div>
                <div class="text">{{ contactInformation.landline_no }}</div>
              </li>
            </ul>
            <hr />
            <h4 class="section-title">Residential Address</h4>
            <ul class="personal-info">
              <li>
                <div class="title">Permanent</div>
                <div class="text">
                  {{ contactInformation.permanent_address }}
                </div>
              </li>
              <li>
                <div class="title">Present</div>
                <div class="text">{{ contactInformation.present_address }}</div>
              </li>
            </ul>
            <hr />
            <h4 class="section-title">Emergency Contacts</h4>
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Number</th>
                    <th>Relation</th>
                  </tr>
                </thead>
                <tbody v-if="emergencyContact.length > 0">
                  <tr v-for="contact in emergencyContact" :key="contact.id">
                    <td>{{ contact.contact_name }}</td>
                    <td>{{ contact.contact_number }}</td>
                    <td>{{ contact.relation_name }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="3">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Family information</h3>
          </div>
          <div class="card-body">
            <ul
              class="personal-info"
              v-for="family in familyInformation"
              :key="family.id"
            >
              <li>
                <div class="title">Spouse Name</div>
                <div class="text">{{ family.spouse_full_name || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Spouse CNIC</div>
                <div class="text">{{ family.spouse_cnic || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Spouse DOB</div>
                <div class="text">{{ family.spouse_dob || "N/A" }}</div>
              </li>
              <li>
                <div class="table-responsive" style="width: 100%">
                  <table
                    class="table table-nowrap table-striped table-bordered"
                  >
                    <thead>
                      <tr>
                        <th>Child's Name</th>
                        <th>Child's DOB</th>
                      </tr>
                    </thead>
                    <tbody v-if="family?.employee_child.length > 0">
                      <tr
                        v-for="child in family.employee_child"
                        :key="child.id"
                      >
                        <td>{{ child.child_full_name }}</td>
                        <td>{{ child.child_dob }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="2">No Data</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Other information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                <div class="title">Passport Number</div>
                <div class="text">{{ otherInformation.passport_number }}</div>
              </li>
              <li>
                <div class="title">Passport Expiry Date</div>
                <div class="text">
                  {{ otherInformation.passport_expiry_date }}
                </div>
              </li>
              <li>
                <div class="title">Driving License Number</div>
                <div class="text">
                  {{ otherInformation.driving_license_number }}
                </div>
              </li>
              <li>
                <div class="title">Driving License Expiry Date</div>
                <div class="text">
                  {{ otherInformation.driving_license_expiry_date }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Education Information</h3>
          </div>
          <div class="card-body">
            <div class="experience-box">
              <ul class="experience-list">
                <li
                  v-for="qualification in qualificationDetails"
                  :key="qualification"
                >
                  <div class="experience-user">
                    <div class="before-circle"></div>
                  </div>
                  <div class="experience-content">
                    <div class="timeline-content">
                      <a href="#/" class="name">{{
                        qualification.university_college_name || "N/A"
                      }}</a>
                      <div>
                        {{ qualification.degree_program_name || "N/A" }}
                      </div>
                      <span class="time"
                        >{{ qualification.degree_start || "N/A" }} -
                        {{ qualification.degree_end || "N/A" }}</span
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-u profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Work Experience</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Employer Name</th>
                    <th>Designation</th>
                    <th>Company Name</th>
                    <th>From Date</th>
                    <th>To Date</th>
                  </tr>
                </thead>
                <tbody v-if="workExperience.length > 0">
                  <tr v-for="work in workExperience" :key="work.id">
                    <td>{{ work.employer_name }}</td>
                    <td>{{ work.designation }}</td>
                    <td>{{ work.company_name }}</td>
                    <td>{{ work.period_from }}</td>
                    <td>{{ work.period_to }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="5">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Positional Information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                <div class="title">Employee ID</div>
                <div class="text">
                  {{ positionalInformation.hcm_id }}
                </div>
              </li>
              <li>
                <div class="title">Pseudo Name</div>
                <div class="text">
                  {{
                    positionalInformation.pseudo_name != null
                      ? positionalInformation.pseudo_name
                      : "N/A"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Business Email</div>
                <div class="text text-email">
                  {{ positionalInformation.business_email }}
                </div>
              </li>
              <li>
                <div class="title">Employee Status</div>
                <div class="text">
                  {{
                    positionalInformation.status_name != null
                      ? positionalInformation.status_name
                      : "N/A"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Duty Type</div>
                <div class="text">{{ positionalInformation.employee_duty_type_name || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Employment Level</div>
                <div class="text">{{ employmentLevel.level || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Employee Grade</div>
                <div class="text">
                  {{ employmentLevel.level }}
                  {{
                    employmentLevel.level && employmentGrade.grade ? "-" : ""
                  }}
                  {{ employmentGrade.grade }}
                </div>
              </li>
              <li>
                <!-- Dependency on employment status (waiting for confirmation ) -->
                <div class="title">Contract Duration</div>
                <div
                  class="text"
                  v-if="positionalInformation.status_name == 'contractual'"
                >
                  {{ contractDetails.contract_from }} -
                  {{ contractDetails.contract_to }}
                </div>
                <div class="text" v-else>N/A</div>
              </li>
              <li>
                <div class="title">Shift Timing</div>
                <div class="text">{{ positionalInformation.shift_name }}</div>
              </li>
              <li>
                <div class="title">Designation</div>
                <div class="text">
                  {{ positionalInformation.designation_name }}
                </div>
              </li>
              <li>
                <div class="title">Section</div>
                <div class="text">{{ positionalInformation.section_name }}</div>
              </li>
              <li>
                <div class="title">Department</div>
                <div class="text">
                  {{ positionalInformation.department_name }}
                </div>
              </li>
              <li>
                <div class="title">Project</div>
                <div class="text">
                  {{ positionalInformation.employee_project_name }}
                </div>
              </li>
              <li>
                <div class="title">Team</div>
                <div class="text">
                  {{ positionalInformation.team_name }}
                </div>
              </li>
              <li>
                <div class="title">Campaign</div>
                <div class="text">
                  {{ positionalInformation.campaigns }}
                </div>
              </li>
              <li>
                <div class="title">Probation Start Date</div>
                <div class="text">
                  {{ positionalInformation.probation_start_date }}
                </div>
              </li>
              <li>
                <div class="title">Probation Ending Date</div>
                <div class="text">
                  {{ positionalInformation.probation_ending_date }}
                </div>
              </li>
              <li>
                <div class="title">Confirmation date (Effective Till)</div>
                <div class="text">
                  {{ positionalInformation.date_of_confirmation }}
                </div>
              </li>
              <li>
                <div class="title">Remote work</div>
                <div class="text">
                  {{ positionalInformation.wfh }}
                </div>
              </li>
              <li>
                <div class="title">Date of Joining</div>
                <div class="text">
                  {{ positionalInformation.joining_date }}
                </div>
              </li>
              <!-- <li>
                <div class="title">Last working date</div>
                <div class="text">
                  {{ positionalInformation.last_working_date || "N/A" }}
                </div>
              </li> -->
              <li>
                <div class="title">Date of Separation</div>
                <div class="text">
                  {{ positionalInformation.date_of_separation || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Reporting Authority</div>
                <div class="text">
                  {{
                    positionalInformation.reporting_authority != null
                      ? positionalInformation.reporting_authority_name
                      : "N/A"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Indirect Reporting Authority</div>
                <div class="text">
                  {{
                    positionalInformation.indirect_authority != null
                      ? positionalInformation.indirect_authority_name
                      : "N/A"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Team Authority</div>
                <div class="text">
                  {{ positionalInformation.team_reporting ? "Yes" : "No" }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Profile Info Tab -->
</template>

<script>
import MyProfileService from "@/services/MyProfileService";

export default {
  data() {
    return {
      personalInformation: {},
      positionalInformation: {},
      contractDetails: {},
      qualificationDetails: {},
      otherInformation: {},
      familyInformation: {},
      workExperience: {},
      contactInformation: {},
      emergencyContact: {},
      employmentLevel: {},
      employmentGrade: {},
      contractDetails: {},
      eobi: [
        {
          month: "Aug",
          year: "2024",
          amount: 2000,
        },
      ],
    };
  },
  props: {
    userProfile: {
      type: Object,
      default: {},
    },
  },

  watch: {
    userProfile: {
      handler() {
        this.personalInformation =
          this.userProfile && this.userProfile.employee_personal_information
            ? this.userProfile.employee_personal_information
            : {};
        this.positionalInformation =
          this.userProfile && this.userProfile.employee_positional_information
            ? this.userProfile.employee_positional_information
            : {};
        this.contractDetails =
          this.userProfile && this.userProfile.employee_contract_detail
            ? this.userProfile.employee_contract_detail
            : {};
        this.qualificationDetails =
          this.userProfile && this.userProfile.employee_qualification
            ? this.userProfile.employee_qualification
            : {};
        this.otherInformation =
          this.userProfile && this.userProfile.employee_other_information
            ? this.userProfile.employee_other_information
            : {};
        this.familyInformation =
          this.userProfile && this.userProfile.employee_family_information
            ? this.userProfile.employee_family_information
            : {};
        this.workExperience =
          this.userProfile && this.userProfile.employee_work_experience
            ? this.userProfile.employee_work_experience
            : {};
        this.contactInformation =
          this.userProfile && this.userProfile.employee_contact_information
            ? this.userProfile.employee_contact_information
            : {};
        this.emergencyContact =
          this.userProfile && this.userProfile.emergency_contact
            ? this.userProfile.emergency_contact
            : {};
        this.employmentLevel =
          this.userProfile && this.userProfile.employment_level
            ? this.userProfile.employment_level
            : {};
        this.employmentGrade =
          this.userProfile && this.userProfile.employment_grade
            ? this.userProfile.employment_grade
            : {};
        this.contractDetails =
          this.userProfile && this.userProfile.employee_contract_detail
            ? this.userProfile.employee_contract_detail
            : {};
      },
      immediate: true,
    },
  },
};
</script>
